import { RingLoader } from "react-spinners"
import { Error } from "../../components/Icon"
import './ErrorPage.scss'

const ErrorPage = () => {
    return (<section className="w-100 d-flex justify-content-center align-items-center">
        <div className="mt-5">
        <div className="text-center">
                    <Error/>
        </div>

                <h1 className="text-center">Whoops! Page not found</h1>
              
                <div className="d-flex justify-content-center align-items-center">
                <h2 className="mt-5 msg" >
                We’re sorry, the page you requested could not be found. Please go back to the Homepage.
                </h2>
                </div>
                <div className="text-center mt-5 mb-5 ">
                    <a href="/" className="btn btn-primary btn-err">
                        Go To Home
                    </a>
                </div>
            </div>
    </section>)
}

export default ErrorPage